import {VERIFY_MSG_UPDATE, VERIFY_MSG_CLEAN} from '../actions/ActionTypes';

const initialState = {
    curStep: 1,
    phone: '',
    phoneName: '',
    phoneErr: '',
    phoneList: [],
    titleName: '',
    distributor: {},
    connectPhone: '',
    connectEmail: '',
};
export function verifyMsgReducer(state = initialState, action) {
    switch (action.type) {
        case VERIFY_MSG_UPDATE:
            return {
                ...state,
                ...action.data
            };
        case VERIFY_MSG_CLEAN:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
